import { useBEMClasses } from "@circle-react/hooks/utils/useBEMClasses";
import classnames from "classnames";

import { legacyClassNames } from "@/react/helpers/cssAnchorHelpers";

export interface RowProps {
  almostFull?: boolean;
  badge?: boolean;
  className?: string;
  extraLong?: boolean;
  full?: boolean;
  half?: boolean;
  isDark?: boolean;
  lg?: boolean;
  long?: boolean;
  md?: boolean;
  short?: boolean;
  sm?: boolean;
  square?: boolean;
  squareExtraLarge?: boolean;
  squareLarge?: boolean;
  x2l?: boolean;
  xl?: boolean;
  xs?: boolean;
  xxl?: boolean;
}

export const Row = ({ className = "", isDark = false, ...props }: RowProps) => {
  const blockElement = classnames(
    legacyClassNames("skeleton-loader__row"),
    className,
  );
  const { modifiers } = useBEMClasses(blockElement, props);

  return (
    <div
      className={classnames(blockElement, modifiers, {
        "!bg-tertiary": !isDark,
        "!bg-overlay-dark": isDark,
      })}
    />
  );
};
